import React from 'react';
import * as MaterialUI from 'material-ui';
import moment from 'moment';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';

import { Field, reduxForm } from 'redux-form/immutable';
import { FORM_ABONO } from 'modules/forms/formConstants';
import * as validations from 'modules/forms/validations';
import * as abonadosActions from 'modules/abonados/action';
import { DatePickerF } from 'modules/forms/component';

moment.locale('es');
const hoy = new Date();

class Abono extends React.Component {
  submitForm = (data) => {
    this.props.dispatch(abonadosActions.setAbono(data.get('fechaDesde'), data.get('fechaHasta'), this.props.abonadoId, this.props.isUser));
    this.props.close();
  };
  closeForm = () => this.props.close();
  componentWillUnmount = () => this.props.dispatch(abonadosActions.setState({ popupFlag: false }));
  render() {
    return (
      <form onSubmit={this.props.handleSubmit(this.submitForm)}>
        <Row className="rowContainer">
          <Col md="6">
            <Field
              name="fechaDesde"
              component={DatePickerF}
              inputProps={{
                fullWidth: true,
                floatingLabelText: 'Fecha inicio',
                autoOk: true,
              }}
              format={(value) => (typeof value == 'string' ? null : value)}
              validate={validations.required}
            />
          </Col>
          <Col md="6">
            <Field
              name="fechaHasta"
              component={DatePickerF}
              inputProps={{
                fullWidth: true,
                floatingLabelText: 'Fecha fin',
                autoOk: true,
              }}
              format={(value) => (typeof value == 'string' ? null : value)}
              validate={validations.required}
            />
          </Col>
          <Col md="12">
            <MaterialUI.RaisedButton className="fullWidthComponent noPadding m-tb-20" label="AGREGAR ABONO" primary={true} type="submit" disabled={this.props.invalid} />
          </Col>

          <Col md="12">
            <MaterialUI.RaisedButton
              className="fullWidthComponent noPadding"
              label="CANCELAR"
              secondary={true}
              onClick={() => {
                this.closeForm();
              }}
            />
          </Col>
        </Row>
      </form>
    );
  }
}

Abono = reduxForm({
  form: FORM_ABONO,
  enableReinitialize: true,
})(Abono);

export default connect(() => ({ initialValues: { fechaDesde: hoy } }))(Abono);



// WEBPACK FOOTER //
// src/modules/abonados/components/abonos.js